<tr>
  <td>
    <div class="preloading"></div>
  </td>
  <td>
    <div class="preloading"></div>
  </td>
  <td>
    <div class="preloading"></div>
  </td>
</tr>